import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/onboard')({
  component: OnboardRouteLayout,
});

function OnboardRouteLayout() {
  return <Outlet />;
}
